import { Injectable, Inject } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwMetaDataFormStateService, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataServiceToken, DwOrmDataService, DwLookupInfo, DwMetaDataServiceToken, DwMetaDataService } from '@devwareapps/devware-cap';
import { RoVehicleEntity, MaintenanceEntity, RoAuctionEntity, AuctionEntity, FleetVehicleEntity, FleetMetaDataItemNames, FleetMetaDataLookups, RoMaintenanceEntity } from '../meta-data/fleet-meta-data.service';
import { combineLatest, Observable, Subscription, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@DwCustomContextDefinition({
    keyName: FleetMaintenanceVehicleContextService.ContextName,
    display: 'Fleet Maintenance - Vehicle Details',
    isGlobal: true,
    //parentItem: FleetMetaDataItemNames.Maintenance, FleetMetaDataItemNames.Auction ]
})
@Injectable()
export class FleetMaintenanceVehicleContextService extends DwCustomContextBase {
    vehicleTypes: DwLookupInfo[];
    departments: DwLookupInfo[];
    static ContextName: string = 'fleetMaintenanceVehicleContext';

    constructor(
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService
    ){
        super();
        this.dwMetaDataService.getLookup(FleetMetaDataLookups.CodeValueFleetVehicleType)
            .subscribe(items => this.vehicleTypes = items);
        this.dwMetaDataService.getLookup(FleetMetaDataLookups.EthosWachterDepartmentAllItems)
            .subscribe(items => this.departments = items);
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const mnt: MaintenanceEntity = resolvedContext?.data;
            const auc: AuctionEntity = resolvedContext?.data;
            const vid : number = mnt?.VehicleId ?? auc?.VehicleId;
            if (vid == undefined)
                return {};
            
            const roVehOb = this.getRoVehicle(vid);
            const roMaintOb = mnt?.MaintenanceId == undefined ? of(null) : this.getRoMaint(mnt?.MaintenanceId);

            return combineLatest([roVehOb, roMaintOb])
                    .pipe(mergeMap(([roVeh, roMaint]) => {
                        const v : RoVehicleEntity = roVeh;
                        const results = {
                                VIN: v.VIN, 
                                DriverName: roMaint?.DriverName ?? v.DriverName, 
                                JobNumber: v.JobNumberId, 
                                Phase: v.Phase, 
                                Plate: v.LicensePlate,
                                Year: v.Year,
                                Make: v.Make,
                                Model: v.Model,
                                Type: this.vehicleTypes?.find(i => i.Id == v.VehicleTypeCv?.toString())?.Display,
                                Department: this.departments?.find(i => i.Id == v.WachterDepartmentId?.toString())?.Display,
                                Status: v.VehicleStatusCv
                            };
                        if (resolvedContext?.data._itemName == 'Maintenance' && resolvedContext?.formApi != undefined)
                            resolvedContext?.formApi.patchFormData({ DriverUserId: v.DriverUserId, 
                                                                     RawDriverName: (v.DriverUserId == undefined ? v.DriverName : null),
                                                                     JobNumberId : v.JobNumberId,
                                                                     CurrentLicensePlate: v.LicensePlate,
                                                                     Phase : v.Phase,
                                                                     IsEmployee : (v.DriverUserId != undefined) });
                        return of(results);
                    }));
        });
        contextDef.attributes = [];
        const attrs = contextDef.attributes;
        const attr = DwAttributeType.Text;
        const type = DwControlType.Textbox;
        var attrDN : DwExpressionAttribute = this.addProperty(  attrs, 'DriverName', 'Driver Name', attr, type);
        var attrVIN : DwExpressionAttribute = this.addProperty( attrs, 'VIN', 'VIN', attr, type);
        var attrJn : DwExpressionAttribute = this.addProperty(  attrs, 'JobNumber', 'Job Number', attr, type);
        var attrPh : DwExpressionAttribute = this.addProperty(  attrs, 'Phase', 'Phase', attr, type);
        var attrPl : DwExpressionAttribute = this.addProperty(  attrs, 'Plate', 'Current License Plate', attr, type);

        var attrYr : DwExpressionAttribute = this.addProperty(  attrs, 'Year', 'Year', attr, type);
        var attrMk : DwExpressionAttribute = this.addProperty(  attrs, 'Make', 'Make', attr, type);
        var attrMd : DwExpressionAttribute = this.addProperty(  attrs, 'Model', 'Model', attr, type);
        var attrTp : DwExpressionAttribute = this.addProperty(  attrs, 'Type', 'Vehicle Type', attr, type);
        var attrDp : DwExpressionAttribute = this.addProperty(  attrs, 'Department', 'Department', attr, type);
        var attrSt : DwExpressionAttribute = this.addProperty(  attrs, 'Status', 'Vehicle Status', attr, type);
        var attrIE : DwExpressionAttribute = this.addProperty(  attrs, 'IsEmployee', 'Is Employee', DwAttributeType.YesNo, DwControlType.RadioButtonList);
    }
    getRoMaint(mid : number) : Observable<RoMaintenanceEntity> {
        return this.dataService.loadEntity(FleetMetaDataItemNames.RoMaintenance, mid);
    }
    getRoVehicle(vid: number) : Observable<RoVehicleEntity>{
        return this.loadRoVehicle(vid);
    }
    loadRoVehicle(vid: number) : Observable<RoVehicleEntity>{
        return this.dataService.loadEntity(FleetMetaDataItemNames.RoVehicle, vid)
    }
}